import { useTranslation } from "react-i18next";
function DeleteNominee(){
    const { t } = useTranslation("common");
    return (
            <>{t("nominee.deleteNomineeText")}</>
    );
}
export default DeleteNominee;